export default function (cookieString) {
    const cookies = {};
    if (cookieString === '') {
        return cookies;
    }

    const list = cookieString.split('; ');

    for (let i = 0; i < list.length; i += 1) {
        const cookie = list[i],
            p = cookie.indexOf('='),
            name = cookie.substring(0, p);
        let value = cookie.substring(p + 1);

        value = decodeURIComponent(value);
        cookies[name] = value;
    }

    return cookies;
}
